import React from "react";
import { CoreValueData } from "../../../models/mockdata";
import { CardAbout } from "../../../components";
import { useTranslation } from "react-i18next";

const AboutList = () => {
  const { t } = useTranslation();

  return (
    <div className="w-[85%] mx-auto max-w-[1140px]">
      <div className="text-center">
        <p className="text-primary text-[3rem] sm:text-[4.375rem] py-[60px] sm:py-[100px]">
          {t("core_value")}
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {CoreValueData?.map((item, index) => {
          return (
            <CardAbout
              content={t(item.content)}
              title={t(item.title)}
              img={item.img}
              key={index}
            />
          );
        })}
      </div>
    </div>
  );
};

export default AboutList;
